/**
 * Library to access flash memory devices and contents
 * 
 * file: usb.js
 * inspiration: http://www.samsungdforum.com/Guide/tut00087/index.html 
 */

Usb = (function(){
	var Usb = {
		USB_CONNECTED_EVENT: 0,
		USB_DISCONNECTED_EVENT: 1,
	};

	$.extend(true, Usb, {
		init: function() {

			this.usbPlugin = null; // usb storage plugin
			this.usbPlugin = document.getElementById("pluginStorage");

			if(this.usbPlugin === null) {
				return false;
			}

			this.printInfo();

			// Subscribe the USB Event
			this.usbPlugin.SubscribeEvent(Usb.USB_CONNECTED_EVENT); // USB connection Event
			this.usbPlugin.SubscribeEvent(Usb.USB_DISCONNECTED_EVENT); // USB Disconnection Event
			this.usbPlugin.OnMessage = 'Usb.onMessage';
		},

		onMessage: function() {
			console.log("[Usb] change on usb devices");
			this.printInfo();
		},

		/**
		 * Print debug info message
		 */
		printInfo: function() {
			var nUSBCount = 0;    // USB Device count
			nUSBCount = this.usbPlugin.GetUSBListSize();
			if(nUSBCount == -1) {
				console.log("[Usb] - No USB Devices Found");
			} else {
				console.log("[Usb] - Found USB devices in count: " + nUSBCount);
			}

			var nid1;
			var nid;
			var nPartition;   // no. of partitions
			for (var i = 0; i < nUSBCount; i++) {
				nid1 = this.usbPlugin.GetUSBDeviceID(i);
				nid = parseInt(nid1);
				console.log("nid = " + nid +", VendorName =" + this.usbPlugin.GetUSBVendorName(nid) + ", ModelName =" + this.usbPlugin.GetUSBModelName(nid));
				nPartition = this.usbPlugin.GetUSBPartitionNum(nid);
				for (var j = 0; j < nPartition; j++) {
					this.mntPath = this.usbPlugin.GetUSBMountPath(nid, j);
					console.log("MountPath = " + this.usbPlugin.GetUSBMountPath(nid, j)+ ", AvailSize = " + this.usbPlugin.GetUSBAvailSize(nid, j)+ ", TotalSize = " + this.usbPlugin.GetUSBTotalSize(nid, j));
				}
			}
		},

		/**
		 * 
		 * @returns {Array}
		 */
		getUSBDevices: function() {
			var USBDevices = [];
			var nUSBCount = 0;    // USB Device count
			nUSBCount = this.usbPlugin.GetUSBListSize();
			if(nUSBCount == -1) {
				console.log("[Usb] - No USB Devices Found");
			} else {
				console.log("[Usb] - Found USB devices in count: " + nUSBCount);
			}

			for (var i = 0; i < nUSBCount; i++) {
				var device = {};
				var nid1 = this.usbPlugin.GetUSBDeviceID(i);
				var nid = parseInt(nid1);
				device.nid = nid;
				device.vendorName = this.usbPlugin.GetUSBVendorName(nid);
				device.modelName = this.usbPlugin.GetUSBModelName(nid);
				device.nPartition = this.usbPlugin.GetUSBPartitionNum(nid);
				device.partition = [];
				for (var j = 0; j < device.nPartition; j++) {
					var partition = {};
					partition.mountPath = this.usbPlugin.GetUSBMountPath(nid, j);
					partition.availSize = this.usbPlugin.GetUSBAvailSize(nid, j);
					partition.totalSize = this.usbPlugin.GetUSBTotalSize(nid, j);
					device.partition.push(partition);
				}
				USBDevices.push(device);
			}
			return USBDevices;
		},

		/**
		 * 
		 * @param USBDevices - it can be get by fn: Usb.getUSBDevices()
		 * @returns
		 */
		getPath: function(USBDevices) {
			var mountPath = null;
			if(typeof(USBDevices) == 'object' && USBDevices.length) {
				if(USBDevices[0].partition.length) {
					mountPath = USBDevices[0].partition[0].mountPath;
				}
			}

			if(mountPath) {
				return ("/dtv/usb/" + mountPath + "/");
			} else {
				return null; 
			}
		},

		/**
		 * 
		 * @param mountPath
		 * @param filePath
		 * @returns {String}
		 */
		getFilePath: function(mountPath, filePath) {
			return ("/dtv/usb/" + mountPath + filePath);
		},

		/**
		 * 
		 * @returns {Boolean}
		 */
		checkUSB: function() {
			if(this.usbPlugin === null) {
				return false;
			}
			var count = this.usbPlugin.GetUSBListSize();
			if(count != -1){
				return true;
			}
			return false;
		}

	});

	return Usb;

})();


/**
 * safe for Chrome
 */
if(navigator.userAgent.indexOf("Chrome") >= 0) {
	$.extend(true, Usb, {
		init: function() { return false; },
		checkUSB: function() { return false; }
	});
}



//////////////////
// WEBPACK FOOTER
// ./js/module/usb.js
// module id = 50
// module chunks = 0